import { useState } from 'react'

import { useQuery } from 'providers/tanstack-query/useQuery'
import { GET_SUPPLY_CHAIN } from './api/query'
import { Data, Variables } from './api/types'
import { SupplyChainSlice, UseGetSupplyChain, UseGetSupplyChainProps } from './types'

export const useGetSupplyChain = ({ id }: UseGetSupplyChainProps): UseGetSupplyChain => {
  const [supplyChain, setSupplyChain] = useState<SupplyChainSlice>()

  useQuery<Variables, Data>({
    onCompleted: async (data: Data): Promise<void> => {
      const { node: supplyChain } = data

      if (supplyChain) {
        setSupplyChain(supplyChain)
      }
    },
    options: { enabled: !!id },
    query: GET_SUPPLY_CHAIN,
    variables: { id: id! },
  })

  return { supplyChain }
}
